<div>
    
    <div class="container-table">
        <div class="top-header">
            <h3>How can we help you</h3>
            <p>Find What you're looking for</p>
        </div>
        <div class="contact-form">
            <!-- Left Image -->
            <div class="left-image">
                <img src="logo/contact-us.png" alt="Support Image">
            </div>
        
            <!-- Form Container -->
            <div class="form-container">
                <div class="card-top card-info">
                    <fa-icon [icon]="['fas', 'circle-info']" ></fa-icon>
                </div>
                <p>Request a call back</p>
                <h3>Get In Touch With Us</h3>
                
                <form [formGroup]="contactUsForm" (ngSubmit)="onSubmit()">
                    <div class="form-row">
                        <div class="form-item">
                        <label for="name">Name <small>*</small></label>
                        <input formControlName="name" type="text" id="name" [readOnly]="userName" />
                        <div  class="error" *ngIf="contactUsForm.get('name')?.invalid && contactUsForm.get('name')?.touched">
                            <small *ngIf="contactUsForm.get('name')?.errors?.['required']">Name is required.</small>
                        </div>
                        </div>
                        <div class="form-item">
                        <label for="mobileNumber">Mobile Number <small>*</small></label>
                        <!-- <input  type="text" formControlName="mobileNumber" id="mobileNumber" maxlength="12" required /> -->
                        <input  type="text" formControlName="mobileNumber" type="text" id="mobileNumber" maxlength="12" [readOnly]="userName" />
                        <div  class="error" *ngIf="contactUsForm.get('mobileNumber')?.invalid && contactUsForm.get('mobileNumber')?.touched">
                            <small *ngIf="contactUsForm.get('mobileNumber')?.errors?.['required']">Mobile Number is required.</small>
                        </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-item">
                        <label for="comments">Comments <small>*</small></label>
                        <input formControlName="comments" type="text" id="comments" required />
                        <div  class="error" *ngIf="contactUsForm.get('comments')?.invalid && contactUsForm.get('comments')?.touched">
                            <small *ngIf="contactUsForm.get('comments')?.errors?.['required']">Comments is required.</small>
                        </div>
                        </div>
                    </div>
                    <!-- <div class="spinner-container" *ngIf="loading">
                        <div class="spinner-circle"></div>
                      </div> -->
                    <div class="button-row">
                        <button type="submit"
                        class="btn-save"
                        [disabled]="loadingService.isLoading('contact-us')"
                        >
                            <fa-icon [icon]="['fas', 'square-phone']" style="font-size: 15px;"></fa-icon> SEND REQUEST
                            <app-spinner
                                *ngIf="loadingService.isLoading('contact-us')" 
                                size="small">
                            </app-spinner>
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div class="form-row">
        </div>
        <!-- Contact Options Section -->
        <div class="form-row card">
            <div class="contact-card">
                <div class="info">
                    <div class="suppert-icon">
                        <!-- <fa-icon [icon]="['fas', 'phone']" ></fa-icon> -->
                        <img src="svg/phone-svgrepo-com.svg" alt="" class="svg">
                        
                    </div>
                    <div class="help-support">
                        <p>Give us a call</p>
                        <h4>+91 9666123023</h4>
                    </div>
                </div>
                <div class="card-bor card-desc">
                    <p>In case of any queries regarding our services</p>
                </div>
            </div>
            <div class="contact-card">
                <div class="info">
                    <div class="suppert-icon">
                        <!-- <fa-icon [icon]="['fas', 'envelope']" ></fa-icon> -->
                        <img src="svg/envelope-mail-svgrepo-com.svg" alt="" class="svg">
                    </div>
                    <div class="help-support">
                        <p>Write to us</p>
                        <h4>contact&#64;kyrainnovations.com</h4>
                    </div>
                </div>
                <div class="card-bor card-desc">
                    <p>We're always here to help you.</p>
                </div>
            </div>
            <div class="contact-card">
                <div class="info">
                    <div class="suppert-icon">
                        <img src="svg/whatsapp-symbol-logo-svgrepo-com.svg" alt="" class="svg">
                    </div>
                    <div class="help-support">
                        <p>Chat with us</p>
                        <button>START CHAT</button>
                    </div>
                </div>
                <div class="card-bor card-desc">
                    <p>We define modern customer services.</p>
                </div>
            </div>
        </div>
    </div>
</div>